/**
 * Chunk an array into tabs of `size`.
 * Used to create tab groups (e.g., 3 groups per tab: A-C, D-F, G-I).
 */
export function chunkGroups<T>(items: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < items.length; i += size) {
        chunks.push(items.slice(i, i + size));
    }
    return chunks;
}

/**
 * Generate a tab label from a chunk of groups.
 * E.g., groups A, B, C -> "A-C"; groups D, E, F -> "D-F".
 * Reads the display label off each item via `getLabel`.
 */
export function getChunkTabLabel<T>(chunk: T[], getLabel: (item: T) => string): string {
    if (chunk.length === 0) return "";
    const first = getLabel(chunk[0]);
    const last = getLabel(chunk[chunk.length - 1]);
    return first === last ? first : `${first}\u2013${last}`;
}
